export default __webpack_public_path__ + "static/media/10_motor_Metabuscadores.8c3c0d92.svg";